import React from "react";
import { Heading, Subheading } from "../../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../design/table";
import { FinancialTransaction } from "../../../models/FinancialTransaction";
import { Avatar } from "../../../design/avatar";
import { useFinancialAccount } from "../../../contexts/FinancialAccountContext";

interface Props {
  financialTransaction: FinancialTransaction;
}

const FinancialTransactionListItem: React.FC<Props> = ({
  financialTransaction,
}) => {
  const { financialAccounts } = useFinancialAccount();
  const account = financialAccounts.find(
    (account) => account._id === financialTransaction.financialAccount,
  );
  return (
    <TableRow
      key={financialTransaction._id}
      href={`/financial-transaction/${financialTransaction._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="w-1/4">
        <div className="flex flex-row gap-2">
          <Avatar src={financialTransaction.logoUrl} className="size-6" />
          <Subheading>
            {financialTransaction.merchantName ?? financialTransaction.name}
          </Subheading>
        </div>
      </TableCell>
      <TableCell className="w-1/4">{financialTransaction.type}</TableCell>
      <TableCell className="w-1/4">{account?.name}</TableCell>
      <TableCell className="w-1/4 text-right">
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: financialTransaction.currency,
        }).format(financialTransaction.amount)}
      </TableCell>
    </TableRow>
  );
};

export default FinancialTransactionListItem;
